import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import { Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import { Info } from 'components/svg';
import './FeeWarningToolTipV2.scss';

// Enhancer with recompose
const enhance = compose(
    withProps(({ feeProps }) => {
        let fees = [
            {
                name: 'One-Time Admin Fee',
                price: feeProps?.admin?.value,
            },
            {
                name: 'One-Time Lock Fee',
                price: feeProps?.lock?.value,
            },
        ];

        const totalFees = feeProps?.totalFees.value;

        fees = fees.filter((fee) => fee.price > 0);

        return {
            fees,
            totalFees,
        };
    })
);

function FeeWarningToolTipV2({
    fees,
    totalFees,
    className,
    triggerAlignment = 'center',
}) {
    return (
        <Tooltip
            content={
                <Text
                    size="tiny"
                    color="gray"
                >
                    The following fees shall apply:
                    {fees && (
                        <ul>
                            {fees.map((fee) => (
                                <li key={fee.name}>
                                    {`${fee.name}: $${fee.price}`}
                                </li>
                            ))}
                        </ul>
                    )}
                </Text>
            }
            clickOnMobile
            fillParentContainer={triggerAlignment}
            simpleButton
            as="div"
        >
            <Info />
            <Text
                last
                size="tiny"
                color="gray"
                className="total-fee-text"
                weight="standard"
            >
                <span>${totalFees} in fees</span>
            </Text>
        </Tooltip>
    );
}

FeeWarningToolTipV2.propTypes = {
    fees: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            price: PropTypes.number,
        })
    ).isRequired,
    totalFees: PropTypes.number.isRequired,
    className: PropTypes.string,
    triggerAlignment: PropTypes.string,
};

export default enhance(FeeWarningToolTipV2);
